import styled from 'styled-components'

const Boton = styled.div`
    text-transform: uppercase;
    font-size: 12px;
    border: none;
    color: #009912;
    background: #d1e5da;
    border-radius: 4px;
    letter-spacing: 1px;
    transition: 200ms ease-in-out;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    padding-top: 5px;
    padding-bottom: 5px;
    padding-left: 8px;
    padding-right: 8px;
    margin-left: 1.1rem;

    &:hover {
        background: #89d9ad;
        color: #0f8d47;
        transition: 200ms ease-in-out;
    }
`
export {
    Boton
}